import { isMaliciousUrl } from "./../link/is-malicious-url.js";
import { normalizeHref } from "./../link/normalize-href.js";
import { getBasedUrl } from "./get-based-url.js";
import { isPageUrl } from "./is-page-url.js";
const getHrefUrl = (url, baseUrl) => typeof url !== "string" ? void 0 : isMaliciousUrl(url) ? void 0 : isPageUrl(url) ? getBasedUrl(url, baseUrl || "") : normalizeHref(url);
export {
  getHrefUrl
};
//# sourceMappingURL=get-href-url.js.map
